import { dataTypes } from '@easybutton/constants'
import { buildIndex } from './indexing'

import mysqlImg from './images/mysql.png'
import postgresImg from './images/postgres.png'
import firestoreImg from './images/firestore.png'
import airtableImg from './images/airtable.png'
import stripeImg from './images/stripe.png'
import mongoImg from './images/mongodb.png'

export const DATABASE_IMAGES = {
  mysql: mysqlImg,
  postgres: postgresImg,
  firestore: firestoreImg,
  airtable: airtableImg,
  stripe: stripeImg,
  mongo: mongoImg,
}

export const getSingularName = (database, tableName) => {
  let table = getTable(database, tableName)

  return (table && table.singularName) || tableName
}

export const getTable = (database, tableName) => {
  if (!database) {
    return null
  }

  let table = database.schema.filter(table => table.name === tableName)[0]

  return table
}

export const getColumn = (table, columnName) => {
  if (!table || !columnName) return

  return table.columns.filter(c => c.name === columnName)[0]
}

export const getColumns = (
  table,
  {
    primaryKey = false,
    hasManys = false,
    labelColumn = true,
    password = false,
    action = false,
  } = {}
) => {
  return table.columns.filter(c => {
    if (!primaryKey && c.name === table.primaryKey) {
      return false
    }

    if (!hasManys && c.dataType === dataTypes.HAS_MANY_RELATION) {
      return false
    }

    if (!labelColumn && c.name === table.labelColumn) {
      return false
    }

    if (!password && c.name.match(/password/i)) {
      return false
    }

    if (action && c.hideFromActions) {
      return false
    }

    return true
  })
}

export const DATABASE_TYPE_OPTIONS = [
  { label: 'Firebase Cloud Firestore', value: 'firestore' },
  { label: 'Airtable', value: 'airtable' },
  { label: 'Stripe', value: 'stripe' },
  { label: 'Postgres', value: 'postgres' },
  { label: 'MySQL', value: 'mysql' },
  { label: 'MongoDB', value: 'mongo' },
].map(itm => ({ ...itm, image: DATABASE_IMAGES[itm.value] }))

export const DATABASE_TYPE_NAMES = buildIndex(
  DATABASE_TYPE_OPTIONS,
  opt => opt.value,
  opt => opt.label
)
